
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Navimumbaitogoacab() {



    const cardData =
    {
        keyword: 'Navi Mumbai to Goa Cab',
        heading: 'S9 Travels:  Navi Mumbai to Goa Cab',
        headingDescription: 'S9 Travels offers Navi Mumbai to Goa Cab Service, ensuring a comfortable, reliable, and hassle-free journey. Whether you are planning a beach vacation, corporate trip, or family getaway, our Innova cabs provide a smooth and enjoyable ride. With spacious interiors, luxury features, and professional drivers, we guarantee a safe and stress-free travel experience. Enjoy on-time pickups, affordable pricing, and 24/7 service. Book your Navi Mumbai to Goa cab with S9 Travels for a seamless and memorable trip!',


        top: 'Top Places to Visit in Goa with S9 Travels',

"topPlaces": [
    {
      "title": "Baga Beach",
      "description": "One of the most popular beaches in Goa, Baga Beach is known for its lively nightlife, water sports, and beachside shacks offering delicious seafood and drinks."
    },
    {
      "title": "Calangute Beach",
      "description": "The largest beach in North Goa, Calangute is often called the 'Queen of Beaches.' It’s famous for its golden sands, water sports, and bustling markets."
    },
    {
      "title": "Basilica of Bom Jesus",
      "description": "A UNESCO World Heritage Site, this 400-year-old church houses the mortal remains of St. Francis Xavier and is an architectural marvel of Baroque style."
    },
    {
      "title": "Dudhsagar Waterfalls",
      "description": "One of India’s tallest waterfalls, Dudhsagar offers breathtaking views, especially during the monsoon. It is a popular trekking and adventure spot."
    },
    {
      "title": "Fort Aguada",
      "description": "A well-preserved 17th-century Portuguese fort overlooking the Arabian Sea. It also houses a lighthouse and offers stunning views of the coastline."
    },
    {
      "title": "Chapora Fort",
      "description": "Famous for its appearance in the Bollywood movie 'Dil Chahta Hai,' Chapora Fort offers spectacular views of the Vagator Beach and the surrounding landscape."
    },
    {
      "title": "Anjuna Flea Market",
      "description": "A vibrant market held every Wednesday, Anjuna Flea Market is perfect for shopping lovers looking for handmade jewelry, clothes, souvenirs, and more."
    },
    {
      "title": "Palolem Beach",
      "description": "A picturesque beach in South Goa, Palolem is known for its calm waters, scenic beauty, and colorful beach huts. It’s perfect for a relaxing getaway."
    },
    {
      "title": "Se Cathedral",
      "description": "One of the largest churches in Asia, Se Cathedral is known for its stunning Portuguese-Gothic architecture and holds religious significance in Goa."
    },
    {
      "title": "Butterfly Beach",
      "description": "A hidden gem in South Goa, Butterfly Beach is known for its serene atmosphere, golden sands, and occasional sightings of dolphins in the sea."
    }
],

"services": [
    {
      "name": "Navi Mumbai to Goa Cab Service",
      "description": "S9 Travels offers convenient and reliable cab services from Navi Mumbai to Goa. Whether you're traveling for a holiday, business, or pilgrimage, our taxis ensure a comfortable and safe journey to Goa."
    },
    {
      "name": "Book Navi Mumbai to Goa Taxi",
      "description": "Booking a taxi from Navi Mumbai to Goa with S9 Travels is simple and quick. Choose from one-way or round-trip options and enjoy a comfortable ride with a professional driver."
    },
    {
      "name": "Navi Mumbai to Goa One-Way Taxi",
      "description": "Planning a one-way trip from Navi Mumbai to Goa? S9 Travels offers affordable and convenient one-way taxi services, ensuring a direct and comfortable ride."
    },
    {
      "name": "Navi Mumbai to Goa Round Trip",
      "description": "S9 Travels provides round-trip cab services from Navi Mumbai to Goa, offering flexibility and convenience for those who wish to explore Goa and return with ease."
    },
    {
      "name": "Affordable Navi Mumbai to Goa Cab",
      "description": "Looking for an affordable taxi service from Navi Mumbai to Goa? S9 Travels offers cost-effective options without compromising on comfort, making it easy to travel in style."
    },
    {
      "name": "Private Taxi for Goa from Navi Mumbai",
      "description": "For a personalized travel experience, choose S9 Travels' private taxi service from Navi Mumbai to Goa. Enjoy a direct, comfortable, and hassle-free ride with our professional drivers."
    },
    {
      "name": "Navi Mumbai to Goa Luxury Cab Service",
      "description": "Travel in style with S9 Travels' luxury cab service from Navi Mumbai to Goa. Enjoy top-notch amenities and a smooth, relaxing ride with our well-maintained vehicles and experienced chauffeurs."
    },
    {
      "name": "Group Travel to Goa from Navi Mumbai",
      "description": "Traveling with a group? S9 Travels offers spacious cabs for group travel from Navi Mumbai to Goa. Our vehicles ensure that everyone travels together comfortably, making the trip enjoyable."
    },
    {
      "name": "Navi Mumbai to Goa Sightseeing by Taxi",
      "description": "Explore Goa's top attractions with S9 Travels' sightseeing taxi service. Our professional drivers will guide you to popular destinations, ensuring a memorable and hassle-free sightseeing experience."
    },
    {
      "name": "Comfortable Taxi Ride from Navi Mumbai to Goa",
      "description": "S9 Travels offers a comfortable and smooth taxi ride from Navi Mumbai to Goa. With well-maintained vehicles and experienced drivers, your journey will be relaxing and enjoyable."
    },
    {
      "name": "Goa Holiday by Taxi from Navi Mumbai",
      "description": "Make your Goa holiday special with a taxi ride from Navi Mumbai. S9 Travels offers personalized services that cater to your needs, ensuring a pleasant and comfortable trip to Goa."
    }
],

"tableData": [
  ["Navi Mumbai to Goa Cab Service", "Book Navi Mumbai to Goa Taxi"],
  ["Navi Mumbai to Goa One-Way Taxi", "Navi Mumbai to Goa Round Trip"],
  ["Affordable Navi Mumbai to Goa Cab", "Private Taxi for Goa from Navi Mumbai"],
  ["Navi Mumbai to Goa Luxury Cab Service", "Group Travel to Goa from Navi Mumbai"],
  ["Navi Mumbai to Goa Sightseeing by Taxi", "Comfortable Taxi Ride from Navi Mumbai to Goa"],
  ["Goa Holiday by Taxi from Navi Mumbai", ""]
],






"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Scenic Ride",
    "WhyChoosedescription": "S9 Travels offers a comfortable and scenic ride from Navi Mumbai to Goa. Our well-maintained vehicles, including the Toyota Innova, provide ample space, air conditioning, and smooth interiors, ensuring that you enjoy a comfortable journey to Goa while taking in the beautiful landscapes along the way."
  },
  {
    "WhyChooseheading": "Timely and Dependable Service",
    "WhyChoosedescription": "Whether you're traveling for a vacation or business, our Navi Mumbai to Goa cab service ensures timely pick-ups and reliable service. Our experienced drivers are dedicated to getting you to your destination without any delays, so you can enjoy your trip without the stress of waiting."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with the Route",
    "WhyChoosedescription": "Our drivers are experienced and well-acquainted with the best routes between Navi Mumbai and Goa. With their expertise in navigating both highways and scenic routes, they ensure that you have a safe, efficient, and comfortable journey from start to finish."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive pricing for the Navi Mumbai to Goa cab service. We believe in transparency, with clear cost breakdowns provided during the booking process, ensuring no hidden charges. You can plan your travel budget with confidence."
  },
  {
    "WhyChooseheading": "Safe and Secure Travel",
    "WhyChoosedescription": "Your safety is our top priority. Our cabs are equipped with modern safety features such as GPS tracking, airbags, and seat belts. Whether you're traveling with family or friends, you can relax knowing you're in safe hands for your journey from Navi Mumbai to Goa."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Travel",
    "WhyChoosedescription": "S9 Travels offers 24/7 availability for your Navi Mumbai to Goa trip, allowing you to book a cab at your convenience, whether for an early morning departure or a late-night return. Our customer service team is always available to assist with your travel needs."
  },
  {
    "WhyChooseheading": "Customizable Travel Itineraries",
    "WhyChoosedescription": "Every journey is unique, and S9 Travels provides customizable travel plans for your Navi Mumbai to Goa trip. Whether you need to make stops along the way or adjust the schedule to suit your preferences, we’ll tailor the trip to meet your specific needs."
  },
  {
    "WhyChooseheading": "Easy and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your Navi Mumbai to Goa cab with S9 Travels is easy and hassle-free. You can conveniently book online via our website or app, or reach out to our customer service team for assistance. We aim to make the booking process smooth and convenient for all our customers."
  }
]












    }


    const faqData = [
        [
          {
            question: 'How can I book a cab from Navi Mumbai to Goa with S9 Travels?',
            answer: 'Booking a cab from Navi Mumbai to Goa is simple! You can book your ride through our website or app, or contact our customer service team for personalized assistance to make your trip smooth and comfortable.',
          },
          {
            question: 'What types of vehicles are available for Navi Mumbai to Goa travel?',
            answer: 'We offer a range of vehicles for your Navi Mumbai to Goa journey, including sedans, SUVs, and premium vehicles like the Toyota Innova. Choose the one that best fits your group size and travel preferences for a comfortable and enjoyable ride.',
          },
          {
            question: 'How long does the journey from Navi Mumbai to Goa take?',
            answer: 'The journey from Navi Mumbai to Goa typically takes around 10 to 12 hours, depending on traffic and road conditions. Our experienced drivers ensure a safe and comfortable trip, with timely arrivals at your destination.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel like Navi Mumbai to Goa?',
            answer: 'Yes, our drivers are highly experienced in long-distance travel and know the best routes to take from Navi Mumbai to Goa. They prioritize safety, comfort, and punctuality to ensure a smooth journey.',
          },
          {
            question: 'Can I book a round trip for Navi Mumbai to Goa?',
            answer: 'Yes, we offer round-trip bookings for your Navi Mumbai to Goa journey. You can schedule your return trip based on your preferred timing, and we will ensure a comfortable and timely return journey back to Navi Mumbai.',
          },
          {
            question: 'Is there a fixed fare for Navi Mumbai to Goa cab service?',
            answer: 'The fare for Navi Mumbai to Goa travel varies based on the type of vehicle, trip duration, and any specific requests you may have. Contact us for an accurate and customized quote for your trip.',
          },
          {
            question: 'Do you provide pickup from Navi Mumbai airport or hotels for Goa trips?',
            answer: 'Yes, we provide convenient pickup services from Navi Mumbai airport or your hotel. Our driver will ensure a seamless transfer, making your journey to Goa stress-free and relaxing from the moment you start.',
          },
          {
            question: 'Can I request additional stops on the way to Goa?',
            answer: 'Yes, we can accommodate any additional stops for sightseeing or breaks during your journey to Goa. Just let us know when booking, and we’ll tailor the trip to include your preferred stops along the way.',
          },
          {
            question: 'Is there any extra charge for waiting or detours during the Navi Mumbai to Goa trip?',
            answer: 'Any extra charges for waiting time or detours will be clearly communicated upfront during your booking. We ensure full transparency in pricing so you can plan your trip without surprises.',
          },
          {
            question: 'Why should I choose S9 Travels for my Navi Mumbai to Goa cab service?',
            answer: 'S9 Travels offers reliable, comfortable, and safe cab services for long journeys like Navi Mumbai to Goa. With professional drivers, well-maintained vehicles, and exceptional customer service, we guarantee a smooth and enjoyable trip.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Rahul Khosla',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab with S9 Travels for a trip from Navi Mumbai to Goa, and the experience was great! The driver was professional, and the vehicle was comfortable for the long journey. We had a smooth ride and reached Goa on time. Highly recommend their services for long-distance travel!”',
        },
        {
          name: 'Mrs. Shalini Rao',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I had an amazing experience traveling from Navi Mumbai to Goa with S9 Travels. The driver was courteous and familiar with the route, and the car was well-maintained. The trip was comfortable and hassle-free, and I would definitely use their services again for future trips!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Navi Mumbai to Goa Cab",
        "description": "Book affordable and reliable Navi Mumbai to Goa cab services for one-way trips, round trips, luxury cabs, and group travel. S9 Travels offers private taxi hire for a comfortable and scenic journey from Navi Mumbai to Goa, perfect for holidays, sightseeing, and hassle-free transportation.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
    
     
      
      
      


    return (
        <div>
        
        <Helmet>
        <title>Navi Mumbai to Goa Cab | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Navi Mumbai to Goa cab services, including one-way, round-trip, and luxury cabs. Comfortable and affordable transport for your Goa holiday, sightseeing tours, and group travel from Navi Mumbai to Goa with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/51.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Navimumbaitogoacab;